import { format } from 'date-fns';
import { useEffect, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import {
  AuditLogGetData,
  endpointAuditLogGET,
} from '~/api/def/endpoints/auditLogEndpoint';
import { AuditTrailTable } from '~/components/ui/tables/ag/auditTrail/auditTrailTable';
import { determineCategory } from './utils/determineCategory';
import { generateAction } from './utils/generateAction';
import { generateDetails } from './utils/generateDetails';

type AuditSectionProps = {
  portfolioCompanyId: string;
};

export default function AuditSection({
  portfolioCompanyId,
}: AuditSectionProps) {
  const [auditTrail, setAuditTrail] = useState<AuditLogGetData[]>([]);

  useEffect(() => {
    // Catch is handled with an error boundary for now
    endpointAuditLogGET({
      entity: 'portfolioCompany',
      entityUuid: portfolioCompanyId,
    }).then((res) => {
      setAuditTrail(res);
    });
  }, [portfolioCompanyId]);

  const rowData = auditTrail.map((audit) => {
    return {
      action: generateAction(audit.changes),
      details: generateDetails(audit.changes),
      user: audit.userDetails?.fullName ?? 'Unknown',
      category: determineCategory(audit),
      timestamp: format(new Date(audit.createdAt), 'yyyy-MM-dd HH:mm:ss'),
    };
  });

  return (
    <div
      className="flex flex-column mt-3 w-full p-3 h-30rem gray-border"
      style={{
        borderRadius: '8px',
      }}
    >
      <>
        <h3 className="w-full">Audit Trail</h3>
        <ErrorBoundary fallback={<div>Error loading audit trail</div>}>
          <AuditTrailTable loading={false} rowData={rowData} />
        </ErrorBoundary>
      </>
    </div>
  );
}
